import { type ChangeEvent, createContext, type FC, type ReactElement, useState } from 'react';
import { usePagination } from '../../content/hooks';
import type { ClientEstateReportData, ClientModel } from '../../models';

interface IReportsContext {
  loading: boolean;
  setLoading: (val: boolean) => void;
  dataUpdate: boolean;
  toggleUpdate: () => void;
  data: ClientEstateReportData[];
  setData: (val: ClientEstateReportData[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  handlePageChange: (_event: any, newPage: number) => void;
  handleLimitChange: (event: ChangeEvent<HTMLInputElement>) => void;
  count: number;
  setCount: (val: number) => void;
  client: ClientModel | null;
  setClient: (val: ClientModel | null) => void;
}

export const ClientEstateContext = createContext<IReportsContext>({} as IReportsContext);

export const ClientEstateProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [dataUpdate, setDataUpdate] = useState(false);
  const toggleUpdate = (): void => setDataUpdate(!dataUpdate);

  const { page, setPage, limit, setLimit, count, setCount, handlePageChange, handleLimitChange } = usePagination(
    toggleUpdate,
    'name',
    'asc'
  );

  const [data, setData] = useState<ClientEstateReportData[]>([]);
  const [loading, setLoading] = useState(false);
  const [client, setClient] = useState<ClientModel | null>(null);

  return (
    <ClientEstateContext.Provider
      value={{
        data,
        setData,
        page,
        setPage,
        limit,
        setLimit,
        handlePageChange,
        handleLimitChange,
        count,
        setCount,
        loading,
        setLoading,
        dataUpdate,
        toggleUpdate,
        client,
        setClient
      }}
    >
      {children}
    </ClientEstateContext.Provider>
  );
};
